import { useGetFreeAssessment } from "@/api/free-assessment/useGetFreeAssessment";
import LoadingScreen from "@/components/Loading";
import { CategoryOverview } from "@/schema/free-assessment/CategoryOverview";
import Heading from "./_components/Heading";
import OverviewTable from "./_components/OverviewTable";

function Overview() {
  const { data, isLoading } = useGetFreeAssessment();

  if (!data || isLoading) {
    return <LoadingScreen />;
  }

  const overviewData: CategoryOverview[] = data.data.main_categories.map(
    (category) => {
      return {
        id: category.id,
        content: category.content,
        subCategoryCount: category.sub_categories.length,
        questionCount: category.sub_categories.reduce(
          (acc, { questions }) => acc + questions.length,
          0,
        ),
      };
    },
  );

  return (
    <div className="mx-8 pb-8 sm:mx-16">
      <Heading />
      <OverviewTable data={overviewData} />
    </div>
  );
}

export default Overview;
